import { createAction, props } from '@ngrx/store';
import { Rider, RiderDTO, RidersFilters } from '../../commons/models/riders';

export const loadRiders = createAction('[Riders] Load Riders', props<{ page?: number, perPage?: number, order?: string, direction?: string, filters?: RidersFilters, includes?: string[] }>());
export const loadRidersCompleted = createAction('[Riders] Load Riders Completed', props<{ riders: RiderDTO[], currentPage: number, total: number, perPage: number, order?: string, direction?: string, filters?: RidersFilters, includes?: string[] }>());
export const loadRidersFailed = createAction('[Riders] Load Riders Failed', props<{ error: any }>());

export const changePage = createAction('[Riders] Change page', props<{ page: number, size: number }>());
export const changeSort = createAction('[Riders] Change sort', props<{ order: string, direction: string }>());
export const changeFilters = createAction('[Riders] Change filters', props<{ filters: RidersFilters }>());

export const editRider = createAction('[Riders] Edit rider', props<{ rider: Rider }>());
export const riderDialogOpened = createAction('[Riders] Detail dialog opened', props<{ dialogId: string }>());
export const closeRidersDialog = createAction('[Riders] Close detail dialog');
export const requestCloseRidersDialog = createAction('[Riders] Request Close Dialog');
export const confirmCloseRidersDialog = createAction('[Riders] Confirm Close Dialog');
export const cancelCloseRidersDialog = createAction('[Riders] Cancel Close Dialog');


export const showRiders = createAction('[Riders] Show rider', props<{ rider: Rider }>());
export const addRiders = createAction('[Riders] Add rider');
export const loadRider = createAction('[Riders] Load rider', props<{ id: number }>());
export const loadRiderCompleted = createAction('[Riders] Load rider Completed', props<{ rider: RiderDTO }>());
export const loadRiderFailed = createAction('[Riders] Load rider Failed', props<{ error: any }>());

export const saveRider = createAction('[Riders] Save rider', props<{ riders: Rider }>());
export const saveRiderCompleted = createAction('[Riders] Save rider completed', props<{ rider: RiderDTO }>());
export const saveRiderFailed = createAction('[Riders] Save rider failed', props<{ error: any }>());

export const deleteRider = createAction('[Riders] Delete rider', props<{ rider: RiderDTO }>());
export const deleteRiderCompleted = createAction('[Riders] Delete rider completed', props<{ rider: RiderDTO }>());
export const deleteRiderCancelled = createAction('[Riders] Delete rider cancelled');
export const deleteRiderFailed = createAction('[Riders] Delete rider failed', props<{ error: any }>());

export const selectRider = createAction('[Riders] Select rider', props<{ filters?: RidersFilters }>());
export const selectionDialogOpened = createAction('[Riders] Selection dialog opened', props<{ selectionDialogId: string }>());
export const closeSelectionDialog = createAction('[Riders] Close selection dialog');
export const riderSelected = createAction('[Riders] Rider selected', props<{ rider: RiderDTO }>());

export const addSelectRiders = createAction('[Riders] Add selected rider', props<{ rider: Rider }>());
export const removeSelectedRiders = createAction('[Riders] Remove selected rider', props<{ rider: Rider }>());
export const resetSelectedRiders = createAction('[Riders] Reset selected riders');
